
  @if(position === "start") {
    <div class="flex justify-end border-red-500 mt-6">
      <button
        class="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors font-medium text-sm shadow-sm"
        matStepperNext [disabled]="fg.invalid">Next</button>
    </div>
  }
  @else if (position === "end") {
    <div class="flex justify-between border-red-500 mt-6">
      <button
        class="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors font-medium text-sm shadow-sm"
        matStepperPrevious>
        Back
      </button>
      <button (click)="runReportClicked()"
        class="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors font-medium text-sm shadow-sm"
              matStepperNext [disabled]="fg.invalid">Run Report</button>
    </div>
  }
  @else if (position === "summary") {
    <div class="flex justify-between border-red-500 mt-6">
      <button (click)="backFromSummaryClicked()"
              class="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors font-medium text-sm shadow-sm"
              matStepperPrevious>
        Back
      </button>
      <button (click)="exportPdf()"
              class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium text-sm shadow-sm"
              matStepperNext>Export PDF</button>
    </div>
  }
  @else {
    <div class="flex justify-between border-red-500 mt-6">
      <button
        class="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors font-medium text-sm shadow-sm"
        matStepperPrevious>
        Back
      </button>

      <button
        class="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors font-medium text-sm shadow-sm"
        matStepperNext [disabled]="fg.invalid">
        Next
      </button>
    </div>
  }


